import { observer } from "mobx-react-lite";
import { PropsWithChildren } from "react";

import { withFetch } from "@ui-components/data-fetcher/DataFetcher.tsx";
import { FilterBar } from "@ui-components/filter-bar/FilterBar.tsx";

import { useAccErrorLogsFilterItems } from "./acc-error-logs-filter-items.tsx";
import { AccErrorLogsFilterValues } from "./AccErrorLogsFilter.types.ts";
import { AccErrorLogsList } from "./AccErrorLogsList.tsx";

const AccErrorLogsFilterBase: React.FC<PropsWithChildren> = observer(() => {
  const filterItems = useAccErrorLogsFilterItems();
  return (
    <FilterBar<AccErrorLogsFilterValues> initialValues={{}} items={filterItems}>
      {({ values }) => <AccErrorLogsList filter={values} />}
    </FilterBar>
  );
});

export const AccErrorLogsFilter = withFetch(
  x => [x.acc.ref.claimStatuses.load(), x.practice.getDefaultInsurers()],
  AccErrorLogsFilterBase
);
